import { defineMessage } from '@redbubble/next/intl';
import ex4FImg from '../assets/models/ex4_f.png';
import ex4MImg from '../assets/models/ex4_m.png';
import { PreQuerySizeGuideData } from '../types';
import {
  howToChooseSizeTshirtInstructions,
  internationalConversions,
  TSHIRT_ILLUSTRATION_PATH,
} from './sharedSizeGuideData';

/**
 * Experience 4
 * Tri-Blend T-Shirt
 * unreal-chinwag
 * Data source: https://www.figma.com/file/APrcJzL2qFEoaRd5cHKcR6/Sizing---VM?node-id=102%3A1188&t=HmvOZ0xrFXTSRYSx-1
 */

export const experience4: PreQuerySizeGuideData = {
  internationalConversions,
  fitIndicator: {
    value: 3.5 /* 1 - 10 */,
  },
  howToChooseSize: {
    imageUrl: TSHIRT_ILLUSTRATION_PATH,
    instructions: howToChooseSizeTshirtInstructions,
  },
  model: {
    male: {
      imageUrl: ex4MImg.src,
      modelSize: defineMessage({
        defaultMessage:
          'Model is wearing size large. He usually wears a size Large.',
      }),
      modelMeasurements: [
        defineMessage({
          defaultMessage: 'Height: 186 cm / 6’1”',
        }),
        defineMessage({
          defaultMessage: 'Chest: 51 cm / 20”',
        }),
      ],
    },
    female: {
      imageUrl: ex4FImg.src,
      modelSize: defineMessage({
        defaultMessage:
          'Model is wearing size small. She usually wears US 6, UK/AU 10, EU 38.',
      }),
      modelMeasurements: [
        defineMessage({
          defaultMessage: 'Height: 167.5 cm / 5’5”',
        }),
        defineMessage({
          defaultMessage: 'Chest: 43 cm / 17”',
        }),
      ],
    },
  },
};
